import { Body1 } from "../typography/Body1.js";
import { Subtitle2 } from "../typography/Subtitle2.js";
import timeline_module_default from "./timeline.module.js";
import { Flex, Timeline } from "@mantine/core";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/timeline/Timeline.tsx
const Timeline$1 = ({ activeStep, steps, color = "secondary", "data-testid": testId }) => {
	const items = steps.map(({ inactive, description, title, subtitle }, ix) => {
		const isCurrentStep = activeStep === ix;
		const itemClassName = [inactive ? timeline_module_default.inactive : "", inactive && isCurrentStep ? timeline_module_default.inactiveBullet : ""].filter(Boolean).join(" ");
		return /* @__PURE__ */ jsx(Timeline.Item, {
			className: itemClassName,
			title: /* @__PURE__ */ jsxs(Flex, {
				justify: "space-between",
				children: [/* @__PURE__ */ jsx(Subtitle2, { children: title }), description ? /* @__PURE__ */ jsx(Body1, { children: description }) : null]
			}),
			children: subtitle
		}, `item-${ix}`);
	});
	return /* @__PURE__ */ jsx(Timeline, {
		active: activeStep,
		bulletSize: 12,
		lineWidth: 2,
		classNames: timeline_module_default,
		style: { "--timeline-color": `var(--mantine-color-${color}-7)` },
		"data-testid": testId,
		children: items
	});
};

//#endregion
export { Timeline$1 as Timeline };